import React from 'react'

import { useRemoteStrings } from '@acorns/web-utils'

import { useBlueprintBindings } from '../utils/blueprint-bindings-context'
import type { GroveBlueprintComponentProps } from '../utils/grove-blueprint-component-props'
import { RenderGroveBlueprintNode } from '../utils/render-grove-blueprint-node'
import { resolveModifiers } from '../utils/resolve-modifiers'
import { resolveRowAlignment } from '../utils/resolve-row-alignment'
import { resolveSpacing } from '../utils/resolve-spacing'

export function GroveBlueprintRow({ node }: GroveBlueprintComponentProps) {
  const { getRemoteString } = useRemoteStrings()
  const { bindingValues } = useBlueprintBindings()

  /* v8 ignore if -- @preserve */
  if (node.type !== 'Row') {
    return null
  }

  const { props, modifiers, children } = node

  const {
    className: modifierClasses,
    style: modifierStyles,
    attributes,
  } = resolveModifiers(modifiers, bindingValues, (key: string) =>
    getRemoteString({ key }),
  )

  const alignmentClass = resolveRowAlignment(props?.alignment)
  const spacingStyle = resolveSpacing(props?.spacing)

  return (
    <div
      className={`flex flex-row ${alignmentClass} ${modifierClasses}`.trim()}
      style={{ ...spacingStyle, ...modifierStyles }}
      {...attributes}
    >
      {children?.map((child, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <RenderGroveBlueprintNode key={index} node={child} />
      ))}
    </div>
  )
}
